export const sources = {
	avif: "__VITE_ASSET__DPZ_gF0t__ 202w",
	webp: "__VITE_ASSET__CPQC1R3F__ 202w"
};
export const img = {
	src: "__VITE_ASSET__C1vKN84x__",
	w: 202,
	h: 242
};
export default {
	sources: sources,
	img: img
};
